<template>
	<div  class="page_content explore_entity_inside program" aria-label="Program Guide Detail page">

    	<div class="row page-heading">
      		<div class="col-7 input module_heading">
        		<div class="module_icon  icon-list"></div>
        		<label v-if="formattedProgramGuide && formattedProgramGuide.title && formattedProgramGuide.title.length > 0" id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="'Program ' + formattedProgramGuide.title">
          			Program: {{formattedProgramGuide.title}}
        		</label>
        		<label v-else id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="'Program ' + formattedCareer.name">Program: {{formattedCareer.name}}</label>

						<b-popover target="programGuideTitle" triggers="hover" placement="top" class="title_popup" container="entityNameContainer">
							<div class="title_container">
							  <template v-if="programGuide && programGuide.title">
									Program: {{programGuide.title}}
								</template>
								<template v-else>
									Program: {{formattedCareer.name}}
								</template>
							</div>
						</b-popover>
						<div id="entityNameContainer" class="title_container_popup"></div>
      		</div>

			<div class="col-5 btn-container">
				<b-btn @click.stop.prevent="goToExploreClicked" :aria-label="deCamelCase()">explore programs</b-btn>
			</div>

    	</div>


	    <div class="row program-guide-section">

		        <div class="col-3 left-tab-panel">
		          <div class="toc_panel">
		            <b-list-group>
		              <div class="list-group-item">
		                <div class="toc_row table-content-header" style="cursor:pointer;">
		                  <span class="header-text">Program Guide</span>
		                </div>
		              </div>
		              <b-list-group-item class="topic-list-item">
		                <div class="toc_row row_1" @click.stop.prevent="introductionClicked" :class="[(selectedComponent === INTRODUCTION) ? 'active' : '']">
		                  <b-link>
		                    <span class="lnk_txt ace_sec_txt" aria-label="Introduction">Introduction</span>
		                  </b-link>
		                </div>

		              </b-list-group-item>
		              <b-list-group-item class="topic-list-item">
		                <div class="toc_row row_1" @click.stop.prevent="careerProspectsClicked" :class="[(selectedComponent === CAREER_PROSPECTS) ? 'active' : '']">
		                  <b-link>
		                    <span class="lnk_txt ace_sec_txt" aria-label="Career Prospects">Career Prospects</span>
		                  </b-link>
		                </div>

		              </b-list-group-item>
	                  <b-list-group-item class="topic-list-item">
	                    <div class="toc_row row_1" @click.stop.prevent="degreeRequirementsClicked" v-b-toggle.degreeRequiremtnSection.degreeRequirmentSectionContainer.degreeRequirmentCollapse.degreeRequirmentExpand :class="[(selectedComponent === DEGREE_REQUIREMENTS) ? 'active' : '']">
	                      <b-collapse class="collapsed icon-collapse icon" aria-label="collapse" id="degreeRequirmentCollapse"></b-collapse>
	                      <b-collapse visible class="expand icon-expand icon" aria-label="expand" id="degreeRequirmentExpand"></b-collapse>
	                      <span class="lnk_txt degree_text ace_sec_txt" aria-label="Degree Requirements">Degree Requirements</span>
	                    </div>
	                  </b-list-group-item>
		              <b-collapse id="degreeRequiremtnSection">
			              <b-list-group-item class="topic-list-item" v-for="category in formattedProgramGuide.categories">
			              	 <b-link @click="handleDegreeRequirementCategoryClicked(category.reqCode)" >
				                <div class="toc_row row_2" >
				                    <span class="lnk_txt ace_sec_txt" :aria-label="category.title">{{category.title}}</span>
				                </div>
			                 </b-link>
			              </b-list-group-item>
			           </b-collapse>

	                 <b-list-group-item v-if="showConcentrationsTab" class="topic-list-item">
	                   <div class="toc_row row_1" @click.stop.prevent="concentrationsClicked" v-b-toggle.concentrationsSection.concentrationsCollapse.concentrationsExpand :class="[(selectedComponent === CONCENTRATIONS) ? 'active' : '']">
	                     <b-collapse class="collapsed icon-collapse icon" aria-label="collapse" id="concentrationsCollapse"></b-collapse>
	                     <b-collapse visible class="expand icon-expand icon" aria-label="expand" id="concentrationsExpand"></b-collapse>
	                     <span class="lnk_txt degree_text ace_sec_txt" aria-label="Concentrations">Concentrations</span>
	                   </div>
	                 </b-list-group-item>
	                 <b-collapse v-if="showConcentrationsTab" id="concentrationsSection">
	                   <b-list-group-item class="topic-list-item" v-for="concentration in formattedProgramGuide.concentrationProgramGuides">
	                      <b-link @click="handleConcentrationClicked(concentration)">
	                       <div class="toc_row row_2">
	                           <span class="lnk_txt ace_sec_txt" :aria-label="concentration.title">{{concentration.title}}</span>
	                       </div>
	                      </b-link>
	                   </b-list-group-item>
	                </b-collapse>
		            </b-list-group>
		          </div>

		        </div>
            <div class="col-6 mid-panel">

              <div class="">
                <div v-if="selectedComponent === INTRODUCTION">
                  <div class="heading">Introduction</div>
                  <div v-html="formattedProgramGuide.description" class="inner-content-section"></div>
                </div>

                <div v-else-if="selectedComponent === CAREER_PROSPECTS">
                  <div class="heading ace_sec_hd" aria-label="Data For USA"><span class="icon icon-filter"></span>Data For USA</div>
                  <div>

                    <b-input-group class="row data-row">
                      <div class="col-4 form-field">
                        <label for="state">State</label>
                        <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                                  :options='formattedGeoIdMap.stateGeoIds' placeholder="Select Any State"></v-select>
                      </div>
                      <div class="col-4 form-field">
                        <label for="state">Metropolitan Statistical Area</label>
                        <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                                  :options='formattedGeoIdMap.msaGeoIds' placeholder="Select Any MSA"></v-select>
                      </div>
                      <div class="col-4 form-field">
                        <label for="state">County</label>
                        <v-select class="select-field" :disabled="disableSelectCounty" v-model='selectedCounty'
                                  :options='formattedGeoIdMap.countyGeoIds' placeholder="Select Any County"></v-select>
                      </div>
                      <b-btn @click="careerSearchClicked" aria-label="Go">Go</b-btn>
                    </b-input-group>

                    <div>
                      <div class="heading ace_sec_hd" aria-label="Job Posting Overview">Job Posting Overview</div>
                      <div class="row postdata-row">
                        <div class="col-6 inner-data ace_sec">
                          <div class="value ace_sec_txt" :aria-label="formattedCareer.aggregatedUniquePosting">{{formattedCareer.aggregatedUniquePosting}}</div>
                          <div class="sm-label ace_sec_txt" aria-label="Unique Postings"> Unique Postings</div>
                          <div class="sm-label">{{formattedCareer.aggregatedTotalPosting}} Total Postings</div>
                        </div>
                        <div class="col-6 inner-data ace_sec">
                          <div class="value ace_sec_txt" :aria-label="formattedCareer.aggregatedPostingIntensity">{{formattedCareer.aggregatedPostingIntensity}}</div>
                          <div class="sm-label ace_sec_txt" aria-label="Posting Intensity">Posting Intensity</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="heading ace_sec_hd" aria-label="Target Occupation">Target Occupation</div>
                      <div class="row postdata-row">
                        <div class="col-4 inner-data ace_sec">
                          <div class="value ace_sec_txt" :aria-label="formattedCareer.aggregatedLastYearJob">{{formattedCareer.aggregatedLastYearJob}}</div>
                          <div class="sm-label ace_sec_txt" :aria-label="'Jobs ' + formattedCareer.endYear"> Jobs ({{formattedCareer.endYear}})</div>
                        </div>
                        <div class="col-4 inner-data ace_sec">
                          <div class="value ace_sec_txt" :aria-label="formattedCareer.aggregatedGrowthPercentage" :style="{'color': (formattedCareer.aggregatedGrowthPercentage > 0 ? '#07d807' : 'red')}">{{formattedCareer.aggregatedGrowthPercentage}}%</div>
                          <div class="sm-label ace_sec_txt" :aria-label="'% Change ' + formattedCareer.timeframe"> % Change ({{formattedCareer.timeframe}})</div>
                        </div>
                        <div class="col-4 inner-data ace_sec" :aria-label="'Median Hourly Earnings $' + formattedCareer.aggregatedMedianHourlyEarning">
                          <div class="value ace_sec_txt">${{formattedCareer.aggregatedMedianHourlyEarning}}/hr</div>
                          <div class="sm-label">Median Hourly Earnings</div>
                        </div>
                      </div>
                      <div v-if="targetOccupationFields.length > 0 && targetOccupationItems.length > 0">
                        <div class="table-container">
                          <b-table :items="targetOccupationItems" class="ace_sec" aria-label="Target Occupation Fields" :fields="targetOccupationFields"/>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="heading-1">Top Companies Posting</div>
                      <div v-if="topCompaniesFields.length > 0 && topCompaniesItems.length > 0">
                        <div class="table-container">
                          <b-table :items="topCompaniesItems" class="ace_sec" aria-label="Top Companies Fields" :fields="topCompaniesFields"/>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="heading-1">Top Skills</div>
                      <div v-if="topSkillsItems.length > 0">
                        <div class="table-container">
                          <b-table :items="topSkillsItems" class="ace_sec" aria-label="Top Skills Fields" :fields="topSkillsFields"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="selectedComponent === DEGREE_REQUIREMENTS">
                  <div id="degreeRequirementsPage">
                    <div class="heading ace_sec_hd" aria-label="Degree Requirements">Degree Requirements</div>
                    <div class="degreeRequirements pg_content_sec">
                      <div v-html="formattedProgramGuide.requirements" class="ace_sec" :aria-label="formattedProgramGuide.requirements">
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="selectedComponent === CONCENTRATIONS">
                  <div id="degreeRequirementsPage">
                    <div class="heading ace_sec_hd" aria-label="Concentrations">Concentrations</div>
                    <div class="degreeRequirements pg_sec">
                      <div class="pg_sec_head ace_sec_txt" :aria-label="formattedSelectedConcentration.title">{{formattedSelectedConcentration.title}}</div>
                    </div>
                    <div class="degreeRequirements pg_content_sec">
                      <div v-html="formattedSelectedConcentration.requirements" class="ace_sec_txt" :aria-label="formattedSelectedConcentration.requirements">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="right-pan">
              <b-tabs>

                <b-tab title="careers" aria-label="careers">
                  <div class="col-3 career-panel">
                    <div v-if="formattedCareers && formattedCareers.length === 0" class="no_data ace_sec_txt" aria-label=" No careers available">
                      No careers available
                    </div>
                    <div v-if="formattedCareers && formattedCareers.length > 0" class="content-section">
                      <template v-for="career in formattedCareers">
                        <a href="#" @click.stop.prevent="goToCareerPage(career)" :aria-label="career.name">{{career.name}}</a>
                      </template>
                    </div>
                  </div>
                </b-tab>

                <b-tab v-if="showRecommendationsTab" title="streams" aria-label="streams">
                  <div class="col-3 career-panel stream_tab_content">
                    <div v-if="isAlumniStreamRecommendationsEnabled">
                      <span class="subhead ace_sec_hd" aria-label="Alumni Streams">Alumni Streams</span>
                      <div v-if="alumniStreamRecommendations && alumniStreamRecommendations.length == 0" class="no_data ace_sec_txt" aria-label="No alumni stream found">
                      	No alumni stream found
                      </div>
                      <div v-if="alumniStreamRecommendations && alumniStreamRecommendations.length > 0" class="content-section">
                        <template v-for="stream in alumniStreamRecommendations">
                          <a href="#" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.streamTitle">{{stream.streamTitle}}</a>
                        </template>
                      </div>
                    </div>
                    <div v-if="isAdvisorStreamRecommendationsEnabled">
                      <span class="subhead ace_sec_hd" aria-label="Advisor Streams">Advisor Streams</span>
                      <div v-if="advisorStreamRecommendations && advisorStreamRecommendations.length == 0" class="no_data ace_sec_txt" aria-label="No advisor stream found">
                      	No advisor stream found
                      </div>
                      <div v-if="advisorStreamRecommendations && advisorStreamRecommendations.length > 0" class="content-section">
                        <template v-for="stream in advisorStreamRecommendations">
                          <a href="#" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.title">{{stream.title}}</a>
                        </template>
                      </div>
                    </div>
                  </div>
                </b-tab>

              </b-tabs>
            </div>

	    </div>
	    <div class="loading-spinner">
		      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
		          <div class="text-center" style="color: #FFF">
		              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
		          </div>
		      </b-modal>
		 </div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'

export default {
  name: 'program-guide-detail',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  data: () => {
    return {
      RECOMMENDATION_TERM_LIMIT: 5,
      selectedState: '',
      selectedMetroArea: '',
      selectedCounty: '',
      toggleExpendIcon: false,
      disableSelectState: false,
      disableSelectMetroArea: false,
      disableSelectCounty: false,
      targetOccupationItems: [],
      topCompaniesItems: [],
      topSkillsFields: ['Skill', 'Postings with Skill'],
      topSkillsItems: [],
      INTRODUCTION: 'Introduction',
      CAREER_PROSPECTS: 'Career Prospects',
      DEGREE_REQUIREMENTS: 'Degree Requirements',
      CONCENTRATIONS: 'Concentrations',
      selectedComponent: '',
      selectedConcentration: {},
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'programGuideList'
    }
  },
  mounted () {
    this.loadDataForProgramGuideDetail()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadProgramCareerResult',
      'loadAlumniStreamRecommendations',
      'loadAdvisorStreamRecommendations',
      'resetProgramCareerResult',
      'loadGeoIds',
      'loadLogDashboardActivity'
    ]),
    async loadDataForProgramGuideDetail () {
      this.showLoader()
      this.resetData()
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let relatedCareers = await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode, showAllOccupations: true })
      let programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      this.setSelectedComponent(programGuide)
      let alumniRecommendationData = this.buildAlumniStreamRecommendationData(programGuide, relatedCareers)
      let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(programGuide)
      this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
      this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
      this.loadGeoIds()
      this.$forceUpdate()
      this.loadLogDashboardActivity({action: 'viewProgramDetail', page: 'programDetail', link: '', programCipCode: cipCode})
      this.hideLoader()
    },
    showLoader () {
      this.$parent.$refs.loadingModal.show()
    },

    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
    },
    introductionClicked () {
      this.selectedComponent = this.INTRODUCTION
    },
    careerProspectsClicked () {
      this.selectedComponent = this.CAREER_PROSPECTS
    },
    degreeRequirementsClicked () {
      this.selectedComponent = this.DEGREE_REQUIREMENTS
    },
    concentrationsClicked () {
      this.selectedComponent = this.CONCENTRATIONS
      // default to first entry in middle panel if null (length already validated with showConcentrationsTab())
      let firstConcentration = this.formattedProgramGuide.concentrationProgramGuides[0]
      let isEmpty = !this.selectedConcentration || !this.selectedConcentration.uuid
      this.selectedConcentration = isEmpty ? firstConcentration : this.selectedConcentration
    },
    handleDegreeRequirementCategoryClicked (reqCode) {
      this.selectedComponent = this.DEGREE_REQUIREMENTS
      let container = $('.mid-panel')
      let containerPos = $('.mid-panel').position()
      let tableSection = $('#' + reqCode)
      let getPos = $(tableSection).position()
      if (getPos && containerPos) {
        $(container).animate({scrollTop: getPos.top - containerPos.top + container.scrollTop() + 150}, 0)
      }
    },
    handleConcentrationClicked (concentration) {
      this.selectedComponent = this.CONCENTRATIONS
      this.selectedConcentration = concentration
    },
    goToCareerPage (career) {
      return this.$router.push({ name: 'careerDetail', params: { code: career.pragyaSoc, returnTo: this.returnTo } })
    },
    goToStreamPage (stream) {
      // Alumni streams have 'streamId' set, Advisor streams just have uuid
      let uuid = (stream.streamId) ? stream.streamId : stream.uuid
      return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
    },
    getLocationParamForCareerSearch () {
      let locationParam = ''
      let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : ''
      let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : ''
      let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : ''

      if (selectedState) {
        locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
      } else if (selectedMetroArea) {
        locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
      } else if (selectedCounty) {
        locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
      }
      return locationParam
    },
    careerSearchClicked () {
      let careerCode = this.formattedCareer.cipCode
      let locationParam = this.getLocationParamForCareerSearch()

      if (!locationParam || !careerCode) {
        return
      }

      this.$refs.loadingModal.show()
      this.loadProgramCareerResult({careerCode: careerCode, locationParam: locationParam}).then(response => {
        this.$refs.loadingModal.hide()
        if (!response) {
          this.$notify({
            group: 'notify',
            type: 'warning',
            title: '',
            text: 'Career search returned zero results.'
          })
        }
        this.$forceUpdate()
      })
    },
    formatOptionsForVSelect (map) {
      let formatted = []
      Object.keys(map).sort().forEach((key, i) => {
        formatted.push({id: key, label: map[key]})
      })
      return formatted
    },
    resetData () {
      // this ensures the original program guide object info binds to the ui
      this.targetOccupationItems = []
      this.topCompaniesItems = []
      this.topSkillsItems = []
      this.resetProgramCareerResult()
    },
    goToExploreClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = 'explore'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    parseTerms (sourceList) {
      if (!sourceList || !sourceList.length) {
        return
      }
      let targetList = []
      let TERM_LIMIT = this.RECOMMENDATION_TERM_LIMIT
      sourceList.forEach((item, i) => {
        if (i < TERM_LIMIT) {
          let curr = JSON.parse(item)
          targetList.push(curr.name)
        }
      })
      return targetList
    },
    buildAlumniStreamRecommendationData (programGuide, careerInfo) {
      let data = {
        'cipCode': programGuide.cipCode,
        'title': programGuide.title,
        'targetOccupations': [],
        'topCompanies': [],
        'topSkills': []
      }

      if (!careerInfo) {
        return data
      }

      data.targetOccupations = this.parseTerms(careerInfo.targetOccupations)
      data.topCompanies = this.parseTerms(careerInfo.topPostingCompanies)
      data.topSkills = this.parseTerms(careerInfo.topSkills)
      return data
    },
    buildAdvisorStreamRecommendationData (programGuide) {
      let data = {
        'requestType': 'programguide',
        'cipCode': programGuide.cipCode,
        'programCode': programGuide.code
      }
      return data
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    setSelectedComponent (programGuide) {
      this.selectedComponent = this.CAREER_PROSPECTS
      if (programGuide && programGuide.description && programGuide.description.length > 0) {
        this.selectedComponent = this.INTRODUCTION
      }
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
      'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
      'packages': state => state.institution.packages,
      'geoIdMap': state => state.career.geoIdMap
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      this.resetData()
      formattedCareer.targetOccupations.forEach((career, i) => {
        let curr = JSON.parse(career)
        if (i === 0) {
          formattedCareer.timeframe = curr.timeframe
          formattedCareer.endYear = curr.year
          formattedCareer.startYear = formattedCareer.endYear - 10
          formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
        }
        let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
        let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
        let currItem = {
          'Occupation': curr.name,
          'Annual Openings': curr.annualOpening,
          'Median Hourly Earnings': curr.medianHourlyEarning
        }
        currItem[tenYearOldJobTitle] = curr.tenYearOldJob
        currItem[growthTitle] = curr.growth
        this.targetOccupationItems.push(currItem)
      })

      formattedCareer.topPostingCompanies.forEach((company, i) => {
        let curr = JSON.parse(company)
        let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
        let currItem = {'Company': curr.name}
        currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
        currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
        this.topCompaniesItems.push(currItem)
      })

      formattedCareer.topSkills.forEach((skill, i) => {
        let curr = JSON.parse(skill)
        let currItem = {'Skill': curr.name, 'Postings with Skill': curr.unique_postings}
        this.topSkillsItems.push(currItem)
      })
      return formattedCareer
    },
    formattedGeoIdMap () {
      let formattedMap = {}
      let map = this.geoIdMap

      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
        formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
        formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
      }
      return formattedMap
    },
    labelsToCodesMap () {
      let map = this.geoIdMap
      let formattedMap = {}
      if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
        formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
        formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
        formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
      }
      return formattedMap
    },
    targetOccupationFields () {
      let fields = ['Occupation']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push((curr.tenYearOldJobTitle))
        fields.push('Annual Openings')
        fields.push('Median Hourly Earnings')
        fields.push('Growth (' + curr.timeframe + ')')
        return fields
      } else {
        return []
      }
    },
    topCompaniesFields () {
      let fields = ['Company']
      if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
        let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
        fields.push('Total/Unique (' + curr.timeframe + ')')
        fields.push('Posting Intensity')
        return fields
      } else {
        return []
      }
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    formattedSelectedConcentration () {
      let selectedConcentration = this.selectedConcentration
      if (!selectedConcentration) {
        return {}
      }
      return selectedConcentration
    },
    showConcentrationsTab () {
      let formattedProgramGuide = this.formattedProgramGuide
      if (!formattedProgramGuide || !formattedProgramGuide.concentrationProgramGuides) {
        return false
      }
      let numberOfConcentrations = formattedProgramGuide.concentrationProgramGuides.length
      return numberOfConcentrations > 0
    }
  },
  watch: {
    selectedState (newState) {
      if (!newState) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = false
        this.disableSelectMetroArea = true
        this.disableSelectCounty = true
      }
    },
    selectedMetroArea (newMSA) {
      if (!newMSA) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = true
        this.disableSelectMetroArea = false
        this.disableSelectCounty = true
      }
    },
    selectedCounty (newCounty) {
      if (!newCounty) {
        this.disableSelectState = false
        this.disableSelectMetroArea = false
        this.disableSelectCounty = false
      } else {
        this.disableSelectState = true
        this.disableSelectMetroArea = true
        this.disableSelectCounty = false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideDetail.vue